import 'angular-loading-overlay';

// Exports overlay module which allows injecting bsLoadingOverlayService.
export default 'bsLoadingOverlay';
